module.exports = __webpack_public_path__ + "static/junsung.yoon-19e0985eaf8d64fd7dacb0d41a34fe61.png";